module.exports = __webpack_public_path__ + "static/media/pause.30702c8c.svg";